import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';

const initialState = {
    data: [],
    pageNumber: 1,
    pageSize: 9999,
    subDivisionCode: '',
    dateFrom: '',
    dateTo: '',
    totalRecords: '',
    totalPages: null,
    error: null,
    isLoading: false,
}

export const fetchPaginatedAllComplaints = createAsyncThunk(
    'complaints/GetAllComplaintsBySubDivisionWithoutStatus',
    async ({ pageSize, pageNumber, subDivisionCode, dateFrom, dateTo, roleTypeId }, { getState }) => {
        const { auth } = getState();
        const { token } = auth;

        let codeToAPI = subDivisionCode;

        if (roleTypeId == 1) {
            codeToAPI = subDivisionCode.toString().slice(0, 2)
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        const raw = JSON.stringify({
            pageNumber: pageNumber,
            pageSize: pageSize,
            SubDivisionCode: codeToAPI == 10 ? 15 : codeToAPI,
            dateFrom: "",
            dateTo: dateTo
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `lineComplaints/GetAllComplaintsBySubDivisionWithoutStatus`, requestOptions);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.Message || 'Complaints API issue!');
        }

        const result = await response.json();
        if (result.Message === "Data Not Found.") {
            throw new Error(result.Message, 'printing error message' || 'Unable to fetch stats!');
        }

        return result;
    }
);

const getAllComplaintsPaginatedSlice = createSlice({
    name: 'getAllComplaints',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.pageNumber += 1;
        },
        previousPage(state) {
            if (state.pageNumber > 1) {
                state.pageNumber -= 1;
            }
        },
        firstPage(state) {
            state.pageNumber = 1;
        },
        lastPage(state, action) {
            state.pageNumber = action.payload;
        },
        resetState(state) {
            state.data = []
            state.pageNumber = 1
            state.pageSize = 9999
            state.subDivisionCode = ''
            state.dateFrom = ''
            state.dateTo = ''
            state.totalRecords = ''
            state.totalPages = null
            state.error = null
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedAllComplaints.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedAllComplaints.fulfilled, (state, action) => {
                console.log("fulfil 1")
                state.isLoading = false;
                if (action.payload.data) {
                    state.data = action.payload.data;
                } else {
                    console.log("fulfil 2")
                    state.data = [];
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1;
                }
                console.log("fulfil 3")
                state.totalRecords = action.payload.totalRecords;
                state.error = null;
            })
            .addCase(fetchPaginatedAllComplaints.rejected, (state, action) => {
                console.log("rejected")

                state.isLoading = false;

                console.log(action.error.message, 'action.error.message.includes("400")')

                if (action.error.message == 'Complaints API issue!') {
                    state.data = [];
                    state.totalPages = null;
                    state.totalRecords = null;
                }

                // if (action.payload.data) {
                //     state.data = action.payload.data;
                // } else {
                //     console.log("rejected 5")
                //     state.data = [];
                // }

            });
    }
});

export const { nextPage, previousPage, firstPage, lastPage, resetState } = getAllComplaintsPaginatedSlice.actions;

export default getAllComplaintsPaginatedSlice.reducer;
